import { render, staticRenderFns } from "./ApplyRelease.vue?vue&type=template&id=27dfd588"
import script from "./ApplyRelease.vue?vue&type=script&lang=js"
export * from "./ApplyRelease.vue?vue&type=script&lang=js"
import style0 from "./ApplyRelease.vue?vue&type=style&index=0&id=27dfd588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports